/**
 * Asynchronously loads the component for Admin
 */

import { lazyLoad } from 'utils/loadable';

export default lazyLoad(
  () => import('./index'),
  module => module.default,
);
